// @flow

import styled from '@emotion/styled';
import { desktopMediaQuery, mobileMediaQuery } from '../config/mediaQuery';

// Header + Nav + Pagination
const componentsHeight = 195;
const mobileComponentsHeight = 265;

export default styled('div')`
  position: relative;
  flex: 1;
  align-items: center;
  justify-content: center;
  display: flex;
  ${mobileMediaQuery} {
    height: ${props =>
      props.isFullPage ? `calc(100vh - ${mobileComponentsHeight}px)` : 'auto'};
    ${props =>
      props.gridHeight && `max-height: ${props.gridHeight}; margin-left: 10px`};
  }
  ${desktopMediaQuery} {
    height: ${props =>
      props.isFullPage ? `calc(100vh - ${componentsHeight}px)` : 'auto'};
  }
  flex-direction: ${props => props.direction || 'rows'};
  ${props =>
    props.hasAllColumnsHidden && `display: 'none'`};
`;
